/* eslint-disable indent */
/* eslint-disable spaced-comment */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
/* eslint-disable no-tabs */
/* eslint-disable no-plusplus */
import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import LabelSingleton from "../../../Common/components/Inputs/LabelsPicker/LabelSingleton/LabelSingleton";
import { getCommercializedRefs } from "../../../Common/utils/api/api";
import t from "../../../Common/utils/translation/translator";
import { selectIntegratedDrivesConfiguration } from "../../../IntegratedDrives/store/slices/integrated_drives";
import { selectRetrofitConfiguration } from "../../../Retrofit/store/slices/retrofit";
import BOMTable from "./BOMTable";

const BillOfMaterials = ({ defaultSortBy }) => {
  const retrofitConfiguration = useSelector(selectRetrofitConfiguration);
  const integratedDrivesConfiguration = useSelector(selectIntegratedDrivesConfiguration);
  const configuration = retrofitConfiguration || integratedDrivesConfiguration;

  const [commercializedRefs, setCommercializedRefs] = useState([]);
  const configLocale = window.msizerConfiguration?.locale || "en-WW";
  const lang =
    window.msizerConfiguration.locale === "en-WW" || !window.msizerConfiguration.locale
      ? "en-GB"
      : window.msizerConfiguration.locale;

  let selectedAccessories = [];

  const productsByReference = configuration?.configData?.axes?.reduce((acc, axis) => {
    //console.log axis bundle data
    const motorReference = axis.bundle?.motorReference;
    const motorDescription =
      axis.bundle?.bundleData?.motor?.translationData?.[0]?.catalogue_product?.long_desc?.translation?.[lang] ||
      axis.bundle?.bundleData?.motor?.description;
    const driveReference = axis.bundle?.driveReference;
    const driveDescription =
      axis.bundle?.bundleData?.drive?.translationData?.[0]?.catalogue_product?.long_desc?.translation?.[lang] ||
      axis.bundle?.bundleData?.drive?.description;
    const gearboxReference = axis.bundle?.bundleData?.gearbox?.commercialReference;
    const gearboxDescription =
      axis.bundle?.bundleData?.gearbox?.translationData?.[0]?.catalogue_product?.long_desc?.translation?.[lang] ||
      axis.bundle?.gearbox?.translationData?.[0]?.catalogue_product?.long_desc?.translation?.[lang] ||
      axis.bundle?.bundleData?.gearbox?.description;
    const adaptationKitReference = axis.bundle?.bundleData?.adaptationKit?.commercialReference;
    const adaptationKitDescription =
      axis.bundle?.bundleData?.adaptationKit?.translationData?.[0]?.catalogue_product?.long_desc?.translation?.[lang] ||
      axis.bundle?.adaptationKit?.translationData?.[0]?.catalogue_product?.long_desc?.translation?.[lang] ||
      axis.bundle?.bundleData?.adaptationKit?.description;
    const integratedDriveReference = axis.bundle?.integratedDrive?.extras?.codification;
    const integratedDriveDescription = t("msizer.ui.integratedDrive");

    if (driveReference) {
      const drive = acc.find((product) => product.productReference === driveReference);
      if (drive) {
        drive.quantity++;
      } else {
        acc.push({
          productReference: driveReference,
          type: "Drive",
          description: driveDescription,
          quantity: 1,
          ean: axis.bundle?.bundleData?.drive?.translationData?.[0]?.catalogue_product?.ean,
          e_num: axis.bundle?.bundleData?.drive?.translationData?.[0]?.catalogue_product?.e_num
        });
      }
    }
    if (integratedDriveReference) {
      const integratedDrive = acc.find((product) => product.productReference === integratedDriveReference);
      if (integratedDrive) {
        integratedDrive.quantity++;
      } else {
        acc.push({
          productReference: integratedDriveReference,
          type: "Integrated_Drive",
          description: integratedDriveDescription,
          quantity: 1,
          ean: null,
          e_num: null
        });
      }
    }
    if (motorReference) {
      // push it if doesn't exist, else increment quantity
      const motor = acc.find((product) => product.productReference === motorReference);
      if (motor) {
        motor.quantity++;
      } else {
        acc.push({
          productReference: motorReference,
          type: "Motor",
          description: motorDescription,
          quantity: 1,
          ean: axis.bundle?.bundleData?.motor?.translationData?.[0]?.catalogue_product?.ean,
          e_num: axis.bundle?.bundleData?.motor?.translationData?.[0]?.catalogue_product?.e_num
        });
      }
    }
    if (gearboxReference) {
      const gearbox = acc.find((product) => product.productReference === gearboxReference);
      if (gearbox) {
        gearbox.quantity++;
      } else {
        acc.push({
          productReference: gearboxReference,
          type: "Gearbox",
          description: gearboxDescription,
          quantity: 1,
          ean: axis.bundle?.bundleData?.gearbox?.translationData?.[0]?.catalogue_product?.ean,
          e_num: axis.bundle?.bundleData?.gearbox?.translationData?.[0]?.catalogue_product?.e_num
        });
      }
    }
    if (adaptationKitReference) {
      const adaptationKit = acc.find((product) => product.productReference === adaptationKitReference);
      if (adaptationKit) {
        adaptationKit.quantity++;
      } else {
        acc.push({
          productReference: adaptationKitReference,
          type: "Adaptation_Kit",
          description: adaptationKitDescription,
          quantity: 1,
          ean: axis.bundle?.bundleData?.adaptationKit?.translationData?.[0]?.catalogue_product?.ean,
          e_num: axis.bundle?.bundleData?.adaptationKit?.translationData?.[0]?.catalogue_product?.e_num
        });
      }
    }

    if (axis?.bundle?.bundleData?.drive?.accessories) {
      selectedAccessories = [];
      axis?.bundle?.bundleData?.drive?.accessories?.forEach((element) => {
        if (element.selected) {
          selectedAccessories.push(element);
        }

        const subAcc = element.subs.filter((sub) => sub.selected);
        for (const sub of subAcc) {
          selectedAccessories.push(sub);
        }
        return;
      });

      selectedAccessories.forEach((element) => {
        const existElement = acc.find((product) => product.productReference === element.commercialReference);
        if (existElement) {
          existElement.quantity += element.quantity;
        } else {
          acc.push({
            productReference: element.commercialReference,
            type: "accessory",
            description: element.mediumDescription,
            quantity: element.quantity,
            ean: null,
            e_num: null
          });
        }
      });
    }
    if (axis?.bundle?.bundleData?.motor?.accessories) {
      selectedAccessories = [];
      axis?.bundle?.bundleData?.motor?.accessories?.forEach((element) => {
        if (element.selected) {
          selectedAccessories.push(element);
        }

        const subAcc = element.subs.filter((sub) => sub.selected);
        for (const sub of subAcc) {
          selectedAccessories.push(sub);
        }
        return;
      });

      selectedAccessories.forEach((element) => {
        const existElement = acc.find((product) => product.productReference === element.commercialReference);
        if (existElement) {
          existElement.quantity += element.quantity;
        } else {
          acc.push({
            productReference: element.commercialReference,
            type: "accessory",
            description: element.mediumDescription,
            quantity: element.quantity,
            ean: null,
            e_num: null
          });
        }
      });
    }
    return acc;
  }, []);

  const productsRefs = productsByReference.map((product) => product.productReference);
  const [sortBy, setSortBy] = useState(defaultSortBy);

  //get only commercialized references
  async function getCommercializedReferences(refIds) {
    await getCommercializedRefs(refIds)
      .then((response) => {
        setCommercializedRefs(response);
      })
      .catch((error) => console.error(error));
  }

  useEffect(() => {
    getCommercializedReferences(productsRefs);
  }, []);

  return (
    <div className="BillOfMaterials text-gray-600">
      <div className="flex justify-between mb-5 print:hidden flex-col md:flex-row">
        <span className="text-lg mb-3 font-semibold">{t("msizer.ui.bill_of_materials")}</span>
        <div className="md:flex md:space-x-1 items-center">
          <span className="text-sm">{t("msizer.ui.sort_by")}</span>
          <div className="flex items-center">
            {["Axis", "Reference", "Type"].map((label, index) => (
              <LabelSingleton
                // eslint-disable-next-line react/no-array-index-key
                key={index}
                label={t(`msizer.ui.${label.toLowerCase()}`)}
                selectedInit={sortBy === label}
                onSelect={() => {
                  setSortBy(label);
                }}
                alwaysSelected
                changeWithInit
              />
            ))}
          </div>
        </div>
      </div>

      <div className="space-y-4">
        {sortBy === "Reference" && (
          <BOMTable tableData={productsByReference} commercializedProducts={commercializedRefs} />
        )}
        {sortBy === "Axis" &&
          configuration.configData?.axes?.map((axis) => (
            <div key={axis.id} className="space-y-1">
              <div className="text-xxs space-y-1">
                {axis?.bundle && (
                  <BOMTable
                    commercializedProducts={commercializedRefs}
                    tableTitle={axis.name}
                    tableHeader={{
                      nominalTorque: axis.configFilters?.applicationDataFilter?.nominalTorque,
                      nominalTorqueResult: axis.bundle?.bundleData?.nominalTorque?.toFixed(2)?.toString(),
                      nominalSpeed: axis.configFilters?.applicationDataFilter?.nominalSpeed,
                      nominalSpeedResult: axis.bundle?.bundleData?.nominalSpeed?.toFixed(2)?.toString(),
                      loadInertia: axis.configFilters?.applicationDataFilter?.loadInertia,
                      loadInertiaResult: axis.bundle?.bundleData?.inertia?.toFixed(2)?.toString(),
                      maxLength: axis.configFilters?.applicationDataFilter?.maxLength,
                      maxLengthResult: axis.bundle?.bundleData?.length?.toFixed(2)?.toString()
                    }}
                    tableData={[
                      {
                        productReference: axis.bundle.driveReference,
                        type: "Drive",
                        description:
                          axis.bundle.bundleData?.drive?.translationData?.[0]?.catalogue_product?.long_desc
                            ?.translation?.[lang] || axis.bundle?.bundleData?.drive?.description,
                        quantity: 1,
                        ean: axis.bundle?.bundleData?.drive?.translationData?.[0]?.catalogue_product?.ean,
                        e_num: axis.bundle?.bundleData?.drive?.translationData?.[0]?.catalogue_product?.e_num
                      },
                      {
                        productReference: axis.bundle.integratedDrive?.extras?.codification,
                        type: "Integrated_Drive",
                        description: t("msizer.ui.integratedDrive"),
                        quantity: 1,
                        ean: null,
                        e_num: null
                      },
                      ...productsByReference.filter((product) => product.type === "accessory"),
                      {
                        productReference: axis.bundle.motorReference,
                        type: "Motor",
                        description:
                          axis.bundle.bundleData?.motor?.translationData?.[0]?.catalogue_product?.long_desc
                            ?.translation?.[lang] || axis.bundle?.bundleData?.motor?.description,
                        quantity: 1,
                        ean: axis.bundle?.bundleData?.motor?.translationData?.[0]?.catalogue_product?.ean,
                        e_num: axis.bundle?.bundleData?.motor?.translationData?.[0]?.catalogue_product?.e_num
                      },
                      {
                        productReference: axis.bundle?.bundleData?.gearbox?.commercialReference,
                        type: "Gearbox",
                        description:
                          axis.bundle.bundleData?.gearbox?.translationData?.[0]?.catalogue_product?.long_desc
                            ?.translation?.[lang] ||
                          axis.bundle?.gearbox?.translationData?.[0]?.catalogue_product?.long_desc?.translation?.[
                            lang
                          ] ||
                          axis.bundle?.bundleData?.gearbox?.description,
                        quantity: 1,
                        ean: axis.bundle?.bundleData?.gearbox?.translationData?.[0]?.catalogue_product?.ean,
                        e_num: axis.bundle?.bundleData?.gearbox?.translationData?.[0]?.catalogue_product?.e_num
                      },
                      {
                        productReference: axis.bundle.bundleData?.adaptationKit?.commercialReference,
                        type: "Adaptation_Kit",
                        description:
                          axis.bundle.bundleData?.adaptationKit?.translationData?.[0]?.catalogue_product?.long_desc
                            ?.translation?.[lang] ||
                          axis.bundle?.adaptationKit?.translationData?.[0]?.catalogue_product?.long_desc?.translation?.[
                            lang
                          ] ||
                          axis.bundle?.bundleData?.adaptationKit?.description,
                        quantity: 1,
                        ean: axis.bundle?.bundleData?.adaptationKit?.translationData?.[0]?.catalogue_product?.ean,
                        e_num: axis.bundle?.bundleData?.adaptationKit?.translationData?.[0]?.catalogue_product?.e_num
                      }
                    ]}
                    axisId={axis.id}
                  />
                )}
              </div>
            </div>
          ))}
        {sortBy === "Type" && (
          <>
            {productsByReference.filter((product) => product.type === "Drive").length > 0 && (
              <BOMTable
                commercializedProducts={commercializedRefs}
                tableTitle={t("msizer.ui.drive")}
                tableData={productsByReference.filter((product) => product.type === "Drive")}
              />
            )}

            {productsByReference.filter((product) => product.type === "Integrated_Drive").length > 0 && (
              <BOMTable
                commercializedProducts={commercializedRefs}
                tableTitle={t("msizer.ui.integratedDrive")}
                tableData={productsByReference.filter((product) => product.type === "Integrated_Drive")}
              />
            )}

            {productsByReference.filter((product) => product.type === "Motor").length > 0 && (
              <BOMTable
                commercializedProducts={commercializedRefs}
                tableTitle={t("msizer.ui.motor")}
                tableData={productsByReference.filter((product) => product.type === "Motor")}
              />
            )}
            {productsByReference.filter((product) => product.type === "Gearbox").length > 0 && (
              <BOMTable
                commercializedProducts={commercializedRefs}
                tableTitle={t("msizer.ui.gearbox")}
                tableData={productsByReference.filter((product) => product.type === "Gearbox")}
              />
            )}

            {productsByReference.filter((product) => product.type === "Adaptation_Kit").length > 0 && (
              <BOMTable
                commercializedProducts={commercializedRefs}
                tableTitle={t("msizer.ui.adaptation_kit")}
                tableData={productsByReference.filter((product) => product.type === "Adaptation_Kit")}
              />
            )}

            {productsByReference.filter((product) => product.type === "accessory").length > 0 && (
              <BOMTable
                commercializedProducts={commercializedRefs}
                tableTitle={t("msizer.ui.accessories")}
                tableData={productsByReference.filter((product) => product.type === "accessory")}
              />
            )}
          </>
        )}
      </div>
    </div>
  );
};

BillOfMaterials.propTypes = {
  defaultSortBy: PropTypes.string
};

BillOfMaterials.defaultProps = {
  defaultSortBy: "Reference"
};

export default BillOfMaterials;
